/**
 * Text with the searched-for substring marked in place.
 *
 * A `<mark>` rather than a styled `<span>`, and that is a semantics decision
 * rather than a shortcut: `<mark>` means *"relevant to the user's current
 * activity"*, which is exactly what a search hit is, and it is the one element
 * assistive technology already announces as such. The styling is `table.css`'s;
 * the meaning is the element's.
 */
import { createElement, Fragment } from "react";
import { markMatch } from "./match.js";
export function Marked({ text, query, mono = false }) {
    const segments = markMatch(text, query);
    return createElement("span", {
        className: mono ? "pp-table-mono" : undefined,
        // The full value in `title`, per the truncation rule — the cell is a
        // single ellipsised line, and this is where the rest of a German product
        // name lives.
        title: text,
    }, ...segments.map((segment, i) => segment.matched
        ? createElement("mark", { key: i, className: "pp-table-mark" }, segment.text)
        : createElement(Fragment, { key: i }, segment.text)));
}
//# sourceMappingURL=Marked.js.map